import { loadPreviewCatalogue } from './meg-preview-feed.js';

async function renderRelated(section) {
  if (section.dataset.loaded) return;
  section.dataset.loaded = 'true';
  const grid = section.querySelector('.meg-related__grid');
  try {
    const { items } = await loadPreviewCatalogue(section.dataset.catalogues.split('|'));
    const path = section.dataset.productPath;
    const productPath = item => new URL(item.nativeUrl, location.origin).pathname;
    const current = items.find(item => productPath(item) === path);
    if (!current) { section.hidden = true; return; }
    const ignored = new Set(['pack','with','black','white','grey','size','piece','pieces','multi','large','small']);
    const words = new Set((current.title.toLowerCase().match(/[a-z]{4,}/g) || []).filter(word => !ignored.has(word)));
    const seen = new Set([path]);
    const ranked = items.filter(item => item.department === current.department && item.available !== false)
      .map(item => ({ item, score: (item.subcategory === current.subcategory ? 100 : 0) + (item.title.toLowerCase().match(/[a-z]{4,}/g) || []).filter(word => words.has(word)).length }))
      .sort((a,b) => b.score - a.score)
      .filter(({item}) => { const key = productPath(item); if (seen.has(key)) return false; seen.add(key); return true; })
      ;
    const closeMatches = ranked.filter(row => row.score % 100 >= 2);
    const related = (closeMatches.length >= 2 ? closeMatches : ranked).slice(0,4).map(({item}) => item);
    if (!related.length) { section.hidden = true; return; }
    const fragment = document.createDocumentFragment();
    for (const item of related) {
      const link = document.createElement('a'); link.className = 'meg-related__card'; link.href = item.nativeUrl;
      const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 400; img.height = 400;
      const title = document.createElement('h3'); title.textContent = item.title;
      const price = document.createElement('p'); price.textContent = new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(item.amount/100);
      link.append(img,title,price); fragment.append(link);
    }
    grid.replaceChildren(fragment);
  } catch (error) {
    grid.textContent = 'Related products are temporarily unavailable.';
    console.warn('MEG related products unavailable', error);
  }
}
document.querySelectorAll('[data-meg-related]').forEach(renderRelated);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-meg-related]').forEach(renderRelated));
